import { render, staticRenderFns } from "./subHeading.vue?vue&type=template&id=090bf8b9&"
import script from "./subHeading.vue?vue&type=script&lang=js&"
export * from "./subHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports